/*
 * angular-scroll-dropdown
 *
 * display dropdown even in div who have overflow=[auto|hidden|scroll]
 *
 */
(function () {
    'use strict';
    angular.module('angular-scroll-dropdown', ['ui.bootstrap'])
        .directive('dropdownscroll', ['$window', function ($window) {
            return {
                restrict: 'C',
                link: function (scope, elm) {
                    var button = elm.find('.dropdown-toggle');
                    var dropdown, dropDownTopInBottom, dropDownTopInTop;
                    var setPosition = function () {
                        dropdown = elm.find('.dropdown-menu-scoll');
                        dropDownTopInBottom = button.offset().top + button.outerHeight() - $window.pageYOffset;
                        dropDownTopInTop = button.offset().top - $window.pageYOffset;
                        if ($(window).height() < (dropDownTopInBottom + dropdown.height())) {
                            dropdown.css('top', (dropDownTopInTop - dropdown.height() - 5) + "px");
                        }
                        else {
                            dropdown.css('top', (dropDownTopInBottom - 8) + "px");
                        }
                        if ($(window).width() < (button.offset().left + 5 + dropdown.width())) {
                            dropdown.css('left', (button.offset().left + 5 - dropdown.width()) + "px");
                        }
                        else {
                            dropdown.css('left', (button.offset().left + 5) + "px");
                        }
                    };
                    // change dropdown position if click on button
                    button.bind('click', function () {
                        setPosition();
                    });
                    // parent is scrolling => updates the position  of the active dropdown (if there is one)
                    scope.$on('contentScroll:scrolling', function (event, scroll) {
                        var dropdown = elm.find('.dropdown-menu-scoll:visible');
                        if (dropdown.length !== 0) {
                            setPosition();
                            if (dropDownTopInTop < scroll.top || dropDownTopInBottom > scroll.bottom) {
                                button.click();
                            }
                        }
                    });
                },
            };
        }])
        .directive('contentscroll', ['$document', '$window', function ($document, $window) {
            return {
                restrict: 'C',
                link: function (scope, elm) {
                    var doc = angular.element($document);
                    // send message to children if scrolling
                    elm.bind('scroll', function () {
                        scope.$broadcast('contentScroll:scrolling', {
                            top: elm.offset().top,
                            bottom: (elm.offset().top + elm.height()),
                        });
                    });
                    // Window has scrolling also
                    doc.bind("scroll", function () {
                        scope.$broadcast('contentScroll:scrolling', {
                            top: elm.offset().top,
                            bottom: (elm.offset().top + elm.height()),
                        });
                    });
                    angular.element($window).bind("resize", function () {
                        scope.$broadcast('contentScroll:scrolling', {
                            top: elm.offset().top,
                            bottom: (elm.offset().top + elm.height()),
                        });
                    });
                },
            };
        }]);
})();
//# sourceMappingURL=angular-scroll-dropdown.js.map